export const CONTEXT_PATH = '/wiki';
